export default __webpack_public_path__ + "f5f8ce7e5ddb31dbabe78cfc67615b52.png";